var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_183052",
    "data-name": "Group 183052",
    transform: "translate(-184 -3493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183051",
    "data-name": "Group 183051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17985",
    "data-name": "Path 17985",
    d: "M0,0H24V24H0ZM0,0H24V24H0ZM0,0H24V24H0ZM0,0H24V24H0Z",
    transform: "translate(184 3493)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30634",
    "data-name": "Group 30634",
    transform: "translate(-784 3102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17583",
    "data-name": "Rectangle 17583",
    width: 24,
    height: 24,
    transform: "translate(968 391)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "visibility_black_24dp",
    transform: "translate(968 391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17983",
    "data-name": "Path 17983",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17984",
    "data-name": "Path 17984",
    d: "M12,6a9.77,9.77,0,0,1,8.82,5.5,9.822,9.822,0,0,1-17.64,0A9.77,9.77,0,0,1,12,6m0-2A11.827,11.827,0,0,0,1,11.5a11.817,11.817,0,0,0,22,0A11.827,11.827,0,0,0,12,4Zm0,5a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,12,9m0-2a4.5,4.5,0,1,0,4.5,4.5A4.507,4.507,0,0,0,12,7Z",
    fill: "#b6b0df"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.a4ea8c04badfceaf1a802220d26c5a2c.svg";
export { ForwardRef as ReactComponent };